
import { CommonModule } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DetailsService } from './new-details.service';
import { ModalNavBarComponent } from './components/modal-navbar/modal-navbar.component';
import { HeaderDetailsComponent } from './components/header/header.component';
import { DetailsHeroComponent } from './components/hero/hero.component';
import { ActionButtonsDetailsLinksComponent } from './components/action-buttons/action-buttons.component';
import { DetailsDescriptionComponent } from './components/description/description.component';
import { DetailsDateRangeComponent } from './components/date-range/date-range.component';
import { DetailsLocationComponent } from './components/location/location.component';
import { DetailsScheduleComponent } from './components/schedule/schedule.component';
import { DetailsPriceComponent } from './components/price/price.component';
import { DetailsExtraFieldsComponent } from './components/extra-fields/extra-fields.component';
import { DetailsOffersComponent } from './components/offers/offers.component';
import { ToolsService } from 'src/app/services/tools.service';
import { IonicModule, ModalController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetData } from 'src/app/interfaces/mat.interface';
import { pointTypeMap } from '../custom-route/interfaces/custom-route.interface';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { TagsComponent } from "./components/tags/tags.component";

@Component({
    selector: 'item-details',
    imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    HeaderDetailsComponent,
    DetailsHeroComponent,
    ActionButtonsDetailsLinksComponent,
    DetailsDescriptionComponent,
    DetailsDateRangeComponent,
    DetailsLocationComponent,
    DetailsScheduleComponent,
    DetailsPriceComponent,
    DetailsExtraFieldsComponent,
    DetailsOffersComponent,
    ModalNavBarComponent,
    DragHandleComponent,
    TagsComponent
],
    standalone: true,
    templateUrl: './new-details.page.html',
    styleUrls: ['./new-details.page.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    encapsulation: ViewEncapsulation.None,
})

export class NewDetailsPage implements OnInit {
  @Input("isModal") isModal: boolean = false;
  @Input("item") item?: any;
  @Input("addItem") addItem?: any;
  @Input("removeItem") removeItem?: any;

  private routerService = inject(Router);
  private routeService = inject(ActivatedRoute);
  private detailsService = inject(DetailsService);
  private userService = inject(UserService);
  private modalController = inject(ModalController);
  public tools = inject(ToolsService);
  public translate = inject(TranslateService);
  private _bottomSheet = inject(MatBottomSheet);
  private _bottomSheetData: BottomSheetData = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });

  public currentUrl = computed(() => this.routerService.url);
  public itemDetails = computed(() => this.detailsService.itemDetails());
  
  private itemId: string;
  
  private nav = this.routerService.getCurrentNavigation();
  public defaultFileImgName: string;
  public categoryNameSlug: string;
  
  ngOnInit(){
    if(this._bottomSheetData && this._bottomSheetData.id) {
      this.itemId = this._bottomSheetData.id.toString();
      this.detailsService.setIsModal(true);
      this.defaultFileImgName = this._bottomSheetData.defaultImg;
      this.categoryNameSlug = this._bottomSheetData.categoryNameSlug;
    } else {
      this.itemId = this.routeService.snapshot.paramMap.get('itemId');
      this.defaultFileImgName = this.nav?.extras?.state?.['defaultFileImgName'];
      this.categoryNameSlug = this.nav?.extras?.state?.['categoryNameSlug'];
    }
    
    this.userService.checkAllUserEntries();
    this.initializeDetailsItem();
  }

  private initializeDetailsItem() {    
    if (this.currentUrl().includes('event') || 
      this.item?.type === 'event' || 
      this._bottomSheetData?.type === pointTypeMap.event)
    {
      this.detailsService.getEventDetailsServiceSignal(this.itemId || this.item?.id)
    }

    if (this.currentUrl().includes('point') || 
      this.item?.type === 'point' ||
      this._bottomSheetData?.type === pointTypeMap.point ||
      this._bottomSheetData?.type === pointTypeMap.restaurant ||
      this._bottomSheetData?.type === pointTypeMap.transport
    )
    {
      this.detailsService.getPointDetailsServiceSignal(this.itemId || this.item?.id)
    } 
  }
  
  fromBottomSheet(): boolean {
    return this.fromPointPlannerCustomRouteDesktop() || this.fromPointPlannerCustomRouteMobile();
  }
  
  fromPointPlannerCustomRouteMobile(): boolean {
    return this._bottomSheetData?.fromPointPlannerCustomRouteMobile || false;
  }
  
  fromPointPlannerCustomRouteDesktop(): boolean {
    return this._bottomSheetData?.fromPointPlannerCustomRouteDesktop || false;
  }
  
  closeBottomSheet() {
    this._bottomSheet.dismiss();
  }
  
  goBack() {
    this._bottomSheet.dismiss();

  }

  acceptItem(){
      this.modalController.dismiss(true);
  }
  
  public isMultimedia(): boolean {
    if (!this.itemDetails().multimedia) return false;
    return this.itemDetails().multimedia.length > 0 &&
           this.itemDetails().multimedia.some(element => element.name !== null && element.name !== undefined);
  }
  
  protected getDefaultImgFromBottomSheetData(): string | undefined {
    return this._bottomSheetData?.defaultImg;
  }

  ngOnDestroy(){
    this.detailsService.resetItemDetails();
  }

}